import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";
import {
    executeApplyooComponentsFunction,
    sendApplyooComponentsNotification
} from "../infrastructure/useApplyooComponent";

export class action_AP_Kendo_GetSelectedRows extends Component implements IActionBase {

    actionCode = "action_AP_Kendo_GetSelectedRows";
    actionName = "Kendo Grid - Get Selected Rows";

    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {

        let currGridElementObj = dataUtils.getElementByClientID(prmActionParameters.SelectedGrid);

        //prmActionParameters.DataBindStr, prmActionParameters.ResultType, prmActionParameters.QuoteText
        sendApplyooComponentsNotification(currGridElementObj.ElementGuid,
            "",
            { command: "GetSelectedRows"
                        , resultDataBindStr: prmActionParameters.DataBindStr
                        , resultType: prmActionParameters.ResultType
                        , quoteText: prmActionParameters.QuoteText  })

        //let dd =  utils_ui.getDataItem(currGridElementObj?.ElementObj?.DataBindStr)

        // function callBackFunction(){
        //     alert(11)
        // }

        // executeApplyooComponentsFunction("onKendo_GetSelectedRows",
        //     {callBackFunction : callBackFunction})
        //APPLYOO.config.Elements.UI_KendoGrid.Functions.getSelectedRows(currGridElementObj, prmActionParameters.DataBindStr, prmActionParameters.ResultType, prmActionParameters.QuoteText);


    }

}